import { axios } from '../index';

import config from '../config';

const URL = `${config.gatewayApiUrl}`;

// legend
export const triggerRTWCheckByLegend = ({
  userId,
  payload,
}: {
  userId: string;
  payload: {
    rtw_share_code: string;
    date_of_birth: string;
  };
}) => {
  return axios.post(`${URL}/admin/v1/checkers/rtw/users/${userId}`, payload);
};

// company admin
export const triggerRTWCheckByCompanyAdmin = ({
  userId,
  companyId,
  payload,
}: {
  userId: string;
  companyId: string;
  payload: {
    rtw_share_code: string;
    date_of_birth: string;
  };
}) => {
  return axios.post(`${URL}/public/v1/checkers/rtw/companies/${companyId}/users/${userId}`, payload);
};

// user
export const triggerRTWCheckByUser = ({
  payload,
}: {
  payload: {
    rtw_share_code: string;
    date_of_birth: string;
  };
}) => {
  return axios.post(`${URL}/public/v1/checkers/rtw`, payload);
};
